import Box from '@mui/material/Box';
import { grey } from '@mui/material/colors';
import Pagination from '@mui/material/Pagination';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import orderBy from 'lodash/orderBy';
import React from 'react';
import { homeStyles } from '.';
import { ContentCategoryName, ContentDocument } from '../../types';

export function ContestLeaderboards(props: {
  content: ContentDocument[];
  loading: boolean;
  isMobile: boolean;
}) {
  // Props
  const { content, loading, isMobile } = props;
  // State
  const [newPage, setNewPage] = React.useState<number>(1);
  const [itemsPerPage] = React.useState<number>(5);
  const dataFiltered = content.filter(
    (c) => c.Category === ContentCategoryName['Leaderboards'],
  );
  const data = orderBy(dataFiltered, 'DdocIndex');

  // Pagination
  const handlePage = (e: React.ChangeEvent<unknown>, page: number) => {
    setNewPage(page);
  };

  // Sort items
  const indexOfLastItem = newPage * itemsPerPage;
  const indexofFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexofFirstItem, indexOfLastItem);

  // Create Sorted Item Element
  const displayContests = currentItems.map(
    ({ DdocId, FileName, ThumbnailContent, ThumbnailName, Title }) => {
      if (FileName) {
        return (
          <Box key={DdocId} flex={1} pb={1}>
            <a
              href={FileName}
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: 'block' }}
            >
              <img
                src={ThumbnailName || ThumbnailContent || undefined}
                alt={Title || ''}
                style={{
                  boxShadow: `0px 0px 5px 1px ${grey[900]}`,
                  width: '100%',
                  cursor: 'pointer',
                  borderRadius: 5,
                }}
              />
            </a>
          </Box>
        );
      } else {
        return (
          <Box key={DdocId} pb={1} flex={1}>
            <img
              src={ThumbnailName || ThumbnailContent || undefined}
              alt={Title || undefined}
              style={{
                boxShadow: `0px 0px 5px 1px ${grey[900]}`,
                width: '100%',
                borderRadius: 5,
                cursor: 'pointer',
              }}
            />
          </Box>
        );
      }
    },
  );

  // Loading Placeholders
  let skeletons = [];
  for (var i = 0; i < itemsPerPage; i++) {
    skeletons.push(
      <Skeleton
        variant="rectangular"
        key={i}
        width="100%"
        height={142}
        style={{
          marginBottom: '16px',
          boxShadow: '2px 2px 5px gray',
        }}
      />,
    );
  }

  return (
    <Paper sx={{ ...homeStyles.section }}>
      <Stack
        width="100%"
        flex={1}
        pb={2}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        justifyContent="space-between"
      >
        <Box
          width="100%"
          py={3}
          sx={{
            ...homeStyles.title,
          }}
        >
          CONTEST LEADERBOARDS
        </Box>

        {!loading && data.length ? (
          <Box
            flex={1}
            px={{ xs: 1, sm: 2, md: 3 }}
            sx={{ minHeight: { xs: 450, md: 690 } }}
          >
            {displayContests}
          </Box>
        ) : (
          <Box sx={{ marginBottom: '16px' }}>
            {skeletons.map((s) => {
              return s;
            })}
          </Box>
        )}

        <Pagination
          count={Math.ceil(data.length / itemsPerPage)}
          variant="text"
          onChange={handlePage}
          size={isMobile ? 'small' : 'medium'}
          sx={{
            ml: 'auto',
            mr: 'auto',
            '& .MuiPaginationItem-root': {
              color: '#fff',
              fontFamily: 'Lato',
              fontWeight: 300,
              fontSize: { xs: 12, sm: 18 },
            },
            '& .MuiPaginationItem-page.Mui-selected': {
              color: '#12D88E',
            },
            '& .MuiPaginationItem-page:hover': {
              backgroundColor: '#12D88E70',
            },
          }}
        />
      </Stack>
    </Paper>
  );
}
